import { MessageRecipient } from '@mailchimp/mailchimp_transactional';
import Mailchimp from '@mailchimp/mailchimp_transactional';
import { CreateLogger, warn } from '@swivl-mono/helpers';
import { Log } from '@swivl-mono/types';

const log = CreateLogger(Log.EMAIL, 'helpers');

export class EmailHelper {
  static client: Mailchimp.ApiClient; // = Mailchimp(process?.env['MAILCHIP_API_KEY']!);
  static initIfNeeded() {
    if (!EmailHelper.client) {
      EmailHelper.client = Mailchimp(process?.env['MAILCHIP_API_KEY']!);
    }
  }
  static send(recipientsArray: MessageRecipient[], subject: string, text: string, fromName?: string) {
    const from = fromName ? fromName : 'Swivl Server';

    //This  is for internal use!

    const message = {
      from_email: 'server@tryswivl.com',
      from_name: from,
      text: text,
      subject: subject,
      to: recipientsArray,
    };

    log('Sending Message', subject, recipientsArray);
    EmailHelper.initIfNeeded();
    EmailHelper.client.messages
      .send({ message: message, async: false })
      .then(function () {
        log('Email Sent!');
        
      })
      .catch(function (e) {
        warn('Error sending email', e, subject, recipientsArray);
      });
  }

  static async sendSingleEmail(toEmail: string, toName: string, fromEmail: string, fromName: string, subject: string, text: string) {
    const emailRecipients: MessageRecipient[] = [{ email: toEmail, name: toName, type: 'to' }];

    //This  is for internal use!

    const message = {
      from_email: fromEmail,
      from_name: fromName,
      text: text,
      subject: subject,
      to: emailRecipients,
    };

    log('Sending Message', message);
    try {
      EmailHelper.initIfNeeded();

      const response = await EmailHelper.client.messages.send({
        message: message,
        async: true,
      });
      log('Email Sent!', response);
      if (response && (response as unknown as Mailchimp.MessagesSendResponse).status !== 'sent') {
        warn('Error sending email', response, message);
        throw new Error('Error sending email');
      }
    } catch (error) {
      warn('Error sending email', error, message);
    }
  }

  static async sendWithTemplate(templateName: string, recipientsArray: { email: string; name: string; type: 'to' }[], from: { name: string; email: string }, subject: string, mergeVars: { name: string; content: string }[]) {
    const message = {
      from_email: from.email,
      from_name: from.name,
      subject: subject,
      to: recipientsArray,
      global_merge_vars: mergeVars,
    };

    try {
      const templatePayload = {
        template_name: templateName,
        template_content: [],
        message: message,
        async: false,
        ip_pool: null,
        send_at: null,
      };

      //
      EmailHelper.initIfNeeded();

      const response = await EmailHelper.client.messages.sendTemplate(templatePayload as any);
      log('response :', response);
    } catch (error) {
      warn('Error in sending email template', error);
    }
  }

  static sendErrorEmail(subject: string, message: string) {
    const emailRecipients: MessageRecipient[] = [
      { email: 'info@tryswivl.com', name: 'Swivl', type: 'to' },
      { email: 'mason@tryswivl.com', name: 'Mason', type: 'to' },
    ];

    EmailHelper.send(emailRecipients, subject, message, 'Swivl Error');
  }
}
